import { Badge, Flex } from 'antd';

import { usePendingOpenReportMessages } from '@/store';
import { formatBadgeCount } from '@/utils';

export const PendingIncidentsBadge = () => {
  const { isLoading, pendingReports } = usePendingOpenReportMessages();

  if (isLoading) return null;

  const displayCount = formatBadgeCount(pendingReports);
  if (!displayCount) return null;

  return (
    <Flex align="center" justify="center">
      <Badge count={displayCount} />
    </Flex>
  );
};
